<template>
  <div class="full-height flex items-center justify-center">
    <div class="center">
      <h1 class="h3n mb4">
        Une erreur technique a été rencontrée, merci de votre compréhension.
      </h1>
      <div class="relative center pt4">
        <a
          :href="$store.getters.alphaURL"
          class="py2 px3 center white red-bg full-height border-none submit-banner caps"
          style="max-width: 200px"
        ><b>Retourner à l'ucpa</b>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  created () {
    this.$store.commit('setLoading', false);
  }
};
</script>

<style>
</style>
